interface ImageActionsProps {
  isGenerating: boolean;
  hasGeneratedImage: boolean;
  onGenerate: () => void;
  onDownload: () => void;
}

export default function ImageActions({
  isGenerating,
  hasGeneratedImage,
  onGenerate,
  onDownload,
}: ImageActionsProps) {
  return (
    <div className="action-row">
      <button
        className="btn-primary"
        type="button"
        onClick={onGenerate}
        disabled={isGenerating}
      >
        {isGenerating ? "Wird generiert..." : "Bild generieren"}
      </button>

      <button
        type="button"
        className="btn-primary"
        onClick={onDownload}
        disabled={isGenerating || !hasGeneratedImage}
      >
        Bild herunterladen
      </button>
    </div>
  );
}